import type { ReactNode } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Dialog } from "../Dialog";

export interface FormDialogProps {
  open: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
  loading?: boolean;
  error?: string | null;
  submitLabel?: string;
  cancelLabel?: string;
  submitDisabled?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg";
}

const FormStack = styled(Stack)({
  marginTop: "4px",
});

/** Dialog shell for forms. Pair with useFormDialog to handle loading/error lifecycle. */
export function FormDialog({
  open,
  title,
  children,
  onClose,
  onSubmit,
  loading = false,
  error,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  submitDisabled = false,
  maxWidth = "sm",
}: FormDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      closeLabel={cancelLabel}
      loading={loading}
      maxWidth={maxWidth}
      actions={
        <Button
          variant="contained"
          onClick={() => void onSubmit()}
          disabled={loading || submitDisabled}
        >
          {loading ? "…" : submitLabel}
        </Button>
      }
    >
      <FormStack gap={2}>
        {error && <Alert severity="error">{error}</Alert>}
        {children}
      </FormStack>
    </Dialog>
  );
}
